import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import Layout from "../components/Layout";
import Breadcrumbs from "../components/Breadcrumbs";
import PreFooterCTA from "../components/PreFooterCTA";
import ServiceAreaMap from "../components/ServiceAreaMap";
import { SERVICE_AREAS, BUSINESS } from "../data/business";

const BREADCRUMBS = [{ label: "Service Areas" }];

export default function ServiceAreas() {
  return (
    <Layout>
      <section className="bg-[#1A1D21] text-white">
        <div className="abc-container py-12 md:py-16">
          <Breadcrumbs items={BREADCRUMBS} />
          <h1 className="font-display mt-4 text-4xl sm:text-5xl font-extrabold">Serving the <span className="text-[#E31D2B]">Baltimore &amp; DC metros</span></h1>
          <p className="mt-4 text-white/80 max-w-2xl text-lg">A service-area business with two local crews — one in the Baltimore area and one in the Temple Hills / DC area. Drain cleaning, sewer camera inspection, hydro-jetting, and sewer line work across both metros. Call any time — 24/7 emergency service.</p>
        </div>
      </section>

      <section className="py-10 md:py-14 abc-bg-pale">
        <div className="abc-container">
          <ServiceAreaMap />
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICE_AREAS.map((a) => (
              <Link to={`/service-areas/${a.slug}`} key={a.slug} className="abc-card p-6 group" data-testid={`area-card-${a.slug}`}>
                <MapPin className="w-5 h-5 text-[#54616E]" />
                <h3 className="font-display font-bold text-lg text-[#1A1D21] mt-3">Drain &amp; sewer in {a.city}, {a.state}</h3>
                <p className="text-sm text-slate-600 mt-1.5">{a.blurb}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#54616E]">View service area <ArrowRight className="w-4 h-4" /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <PreFooterCTA />
    </Layout>
  );
}
